import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ai-confirm-dialog',
  templateUrl: './ai-confirm-dialog.component.html',
  styleUrls: ['./ai-confirm-dialog.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class AiConfirmDialogComponent implements OnInit {
  agreementChecked = false;

  constructor(public dialogRef: MatDialogRef<AiConfirmDialogComponent>) {}

  ngOnInit(): void {}

  onConfirm(): void {
    this.dialogRef.close(this.agreementChecked);
  }
}
